export default __webpack_public_path__ + "static/media/logo-poxalulu-vertical.13125e05.svg";